import React from "react";
import { PageSection } from "../common/pageSection/PageSection";
import { AboutSection } from "../../graphql/schema";
import {
  makeStyles,
  tokens,
  shorthands,
  Text,
} from "@fluentui/react-components";
import Img from "../common/image/Img";
import { RichText } from "../../helper/richTextHelper";

const useStyles = makeStyles({
  wrapper: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "start",
    maxWidth: "800px",
    ...shorthands.margin(0, "auto"),
    ...shorthands.padding(
      tokens.spacingVerticalXXXL,
      tokens.spacingHorizontalXXXL
    ),
    ...shorthands.borderRadius("20px"),

    rowGap: tokens.spacingVerticalM,
    color: tokens.colorBrandBackground,
    backgroundColor: "#FFFFFF",
  },
  contentWrapper: {
    display: "flex",
    flexDirection: "column",
    rowGap: "52px",
  },
  header: {
    display: "flex",
    alignItems: "center",
    ...shorthands.margin(tokens.spacingVerticalS, 0),
  },
  quoteWrapper: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    columnGap: tokens.spacingHorizontalXXL,
  },
  quoteImage: {
    objectFit: "cover",
    center: "center",
    width: "175px",
    height: "175px",

    ...shorthands.borderRadius("50%"),
  },
  quoteText: {
    display: "flex",
    flexDirection: "column",
    rowGap: tokens.spacingVerticalM,
  },
  partnerImage: {
    maxWidth: "150px",
  },
  partnerImagesContainer: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    ...shorthands.margin(tokens.spacingVerticalM, 0),
    columnGap: tokens.spacingHorizontalL,
    rowGap: tokens.spacingVerticalL,
  },
  rowGap: {
    display: "flex",
    flexDirection: "column",
    rowGap: tokens.spacingVerticalXL,
  },
  clickable: {
    cursor: "pointer",
  },
});

type AboutUsProps = {
  data?: any;
};

export const AboutUs = ({ data }: AboutUsProps): JSX.Element => {
  const classes = useStyles();

  if(data === undefined) return <></>;
  const aboutSection: AboutSection = data?.aboutSection;

  return (
    <PageSection id="contact">
      <article className={classes.wrapper}>
        <Text size={700} weight="bold">
          {aboutSection?.aboutTitle ?? ""}
        </Text>

        <section className={classes.contentWrapper}>
          {aboutSection?.content?.map((block: any, i: number) => {
            switch (block.__typename) {
              case "ComponentAboutText":
                return (
                  <section key={i}>
                    <Text
                      size={500}
                      weight="semibold"
                      className={classes.header}
                    >
                      {block.Title}
                    </Text>
                    {RichText({ blocks: block.Text })}
                  </section>
                );

              case "ComponentAboutQuote":
                return (
                  <section key={i} className={classes.quoteWrapper}>
                    <Img
                      src={block.image?.url ?? ""}
                      alt={block.image?.alternativeText || ""}
                      className={classes.quoteImage}
                    />

                    <div className={classes.quoteText}>
                      <Text size={500} weight="medium" italic>
                        {block.quote}
                      </Text>
                      <Text size={400}>{block.quoteBy}</Text>
                    </div>
                  </section>
                );

              case "ComponentAboutPartner":
                return (
                  <section key={i} className={classes.rowGap}>
                    <Text
                      size={500}
                      weight="semibold"
                      className={classes.header}
                    >
                      {aboutSection?.partnerTitle}
                    </Text>

                    <div className={classes.partnerImagesContainer}>
                      <div className={classes.partnerImage}>
                          <Img
                          className={classes.clickable}
                          src={block.image?.url ?? ""}
                          alt={
                            block.image?.alternativeText ||
                            block.name ||
                            ""
                          }
                          onClick={() =>
                            (window.location.href = block.partnerUrl)
                          }
                        />
                      </div>
                    </div>
                  </section>
                );

              default:
                return null;
            }
          })}
        </section>
      </article>
    </PageSection>
  );
};
